/**
 * Traditional Chinese (zh-TW) translations for the free test feature
 */
const freeTest = {
  freeTest: {
    // Free test page
    title: "紫微斗數免費測試",
    subtitle: "免費體驗紫微斗數命盤解析！",
    limitedTime: "免費測試 - 無需註冊帳戶",
    aboutTitle: "關於此免費測試",
    aboutDescription: "此免費測試讓您無需建立帳戶即可體驗紫微斗數命盤分析的強大功能。",
    whatYouGet: "您將獲得什麼",
    feature1: "完整的紫微斗數命盤視覺化",
    feature2: "基本性格分析",
    feature3: "生活領域概覽",
    fullFeatures: "想要完整功能？",
    upgradeDescription: "透過 WhatsApp 聯繫我們，獲取完整分析、個人諮詢及更多服務。",
    signUpCta: "透過 WhatsApp 聯繫",
    tryAgain: "重試",

    // Free result page
    resultTitle: "免費命盤結果",
    resultTitleSuffix: "的免費命盤結果",
    resultSubtitle: "紫微斗數免費測試結果",
    upgradeTitle: "解鎖完整分析",
    upgradeBenefits: "透過 WhatsApp 聯繫我們，獲取完整個人分析、諮詢及更多服務！",
    createAccount: "透過 WhatsApp 聯繫",
    createAnother: "建立另一個命盤",
    previewVersion: "預覽版本",
    limitedAnalysis: "有限預覽分析",
    limitedAnalysisDesc: "此免費測試提供基本分析的預覽。透過 WhatsApp 聯繫我們以解鎖您命盤的完整詳細分析和解讀。",
    unlockFull: "透過 WhatsApp 聯繫",
    moreAvailable: "更多分析可用",
    moreAnalysisDesc: "透過 WhatsApp 聯繫我們，解鎖詳細分析，包括四化分析、事業洞察、人際相容性等更多內容。",
    createAccountCta: "立即透過 WhatsApp 聯繫",

    // Error messages
    errorNotFound: "找不到此命盤。",
    errorLoadFailed: "命盤資料載入失敗。",
    errorCalculationFailed: "命盤計算失敗。",
    errorExpired: "此命盤可能已過期或已被移除。",
  },

  // Free test ended page
  freeTestEnded: {
    title: "免費測試暫不可用",
    description: "免費測試目前不可用。感謝您對我們紫微斗數命盤分析的關注！",
    whatNow: "現在怎麼辦？",
    createAccount: "您仍可透過 WhatsApp 聯繫我們，使用所有功能。我們的完整服務提供：",
    feature1: "完整的紫微斗數命盤視覺化和分析",
    feature2: "為您自己和他人提供個人化諮詢",
    feature3: "詳細的性格分析和人生預測",
    feature4: "專家洞察和命盤建議",
    signUpCta: "透過 WhatsApp 聯繫",
    signInCta: "了解更多",
    questions: "有問題或意見？",
    contactUs: "透過 WhatsApp 聯繫我們",
  },

  // Free test not started page
  freeTestNotStarted: {
    title: "免費測試即將推出",
    description: "我們的促銷免費測試即將推出。請稍後再來查看！",
  },

  // Free test disabled page
  freeTestDisabled: {
    title: "免費測試暫不可用",
    description: "免費測試功能目前已停用。請透過 WhatsApp 聯繫我們，了解更多關於我們服務的資訊。",
  },

  // Promotional component
  freeTestPromo: {
    limitedOffer: "免費測試",
    daysLeft: "無需註冊",
    title: "免費紫微斗數命盤解讀",
    description: "免費體驗紫微斗數命盤分析的強大功能。無需帳戶！",
    tryNow: "立即嘗試",
    createAccount: "建立完整帳戶",
  },
};

export default freeTest;
